export function assign_error(errors, field, message) {
    if (message) {
        errors[String(field)] = message;
    }
}

export function validate_required(value, label = "Field", message = "") {
    const has_value = Array.isArray(value)
        ? value.length > 0
        : value !== undefined && value !== null && String(value).trim() !== "";

    return has_value ? "" : message || `${label} is required.`;
}

export function validate_email(value) {
    const required_error = validate_required(value, "Email");

    if (required_error) return required_error;

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim())
        ? ""
        : "Please enter a valid email address.";
}

export function validate_person_name(value, label = "Name") {
    const required_error = validate_required(value, label);

    if (required_error) return required_error;

    return String(value).trim().length >= 2 ? "" : `${label} must be at least 2 characters.`;
}

export function validate_phone_number(value) {
    const phone_number = String(value || "").trim();
    const required_error = validate_required(phone_number, "Phone number");

    if (required_error) return required_error;

    return /^[0-9]{10}$/.test(phone_number)
        ? ""
        : "Please enter a 10-digit phone number.";
}
